import React from 'react'
// import classes from './processing.module.css'
// import { isMobile } from '../../../../../../Constants'

const Processing = ({
    step=1,
    setStep='',
    details=[],
    setDetails=''
}) => {
    return (
        <>
        <center>
            <br/><br/>
            <div style={{border:'1px solid grey', padding:'1%', color:'#393186'}}>
                <h4>Thankyou for uploading your file.</h4>
                <h4>Your file is currently been processed...</h4>
            </div><br/>
        </center>
        {/* <div>
            <span style={{fontWeight: 'bold', fontStyle: 'italic'}}>Note : Please note benchmark will be visible to lanes equivalent to Remaining Lanes Credits. Incase uploaded lanes are greater then the Remaining Lanes Credits, system will display the lanes sequentially.
            To get more credits please contact us on connect@logisticsnow.in.</span>
        </div> */}
        </>
    )
}

export default Processing